const LOUNGE_OFFER_RANKS: Record<string, number> = {
  'cln:DXB': 2,
  'led:006RF00000GaxzfYAB': 2,
  'cln:DFW': 3,
  'cln:LHR': 4,
  'led:006RF00000MyGYKYA3': 4,
  'cln:IST': 5,
  'cln:DEL': 6,
  'cln:HND': 7,
  'cln:ORD': 8,
  'cln:PVG': 9,
  'cln:ICN': 13,
  'led:006RF00000MDf2LYAT': 13,
  'led:006RF00000MDf2MYAT': 13,
  'led:006RF00000MDf2NYAT': 13,
  'cln:BOM': 14,
  'cln:JFK': 15,
  'cln:BKK': 16,
  'led:006RF00000O6qKgYAJ': 16,
  'cln:AMS': 17,
  'cln:PEK': 18,
  'cln:CAN': 19,
  'cln:SIN': 20,
  'led:006Ii000002JJv2IAG': 20,
  'cln:FRA': 21,
  'cln:MAD': 22,
  'cln:TFU': 24,
  'cln:SZX': 25,
  'cln:BCN': 26,
  'cln:KUL': 27,
  'led:006RF00000MDf2QYAT': 27,
  'led:006RF00000MDf2RYAT': 27,
  'cln:PKX': 28,
  'asp:208': 29,
  'cln:SYD': 29,
  'cln:NRT': 30,
  'cln:DOH': 31,
  'cln:SHA': 32,
  'cln:MUC': 33,
  'cln:SGN': 34,
  'led:006RF00000GdXcPYAV': 34,
  'asp:207': 35,
  'cln:MEL': 35,
  'cln:HKG': 36,
  'cln:CGK': 37,
  'cln:JED': 38,
  'cln:DPS': 39,
  'cln:HAN': 40,
  'led:006RF00000GdWRqYAN': 40,
  'cln:BLR': 41,
  'cln:RUH': 42,
  'cln:IAH': 44,
  'cln:ORY': 45,
  'cln:SAW': 46,
  'led:006RF00000MDf2cYAD': 46,
  'cln:BNE': 47,
  'led:006Ii000002JJwsIAG': 47,
  'cln:LGA': 48,
  'cln:IAD': 49,
  'cln:SFO': 50,
  'cln:MIA': 51,
  'cln:PHX': 52,
  'cln:MSP': 54,
  'cln:BOS': 55,
  'cln:DTW': 56,
  'cln:FCO': 57,
  'cln:PHL': 58,
  'cln:LAS': 59,
  'cln:MCO': 60,
  'cln:YYZ': 62,
  'cln:AUH': 64,
  'cln:DMM': 65,
  'cln:HYD': 66,
  'cln:CCU': 67,
  'cln:MNL': 68,
  'cln:SUB': 69,
  'cln:DMK': 70,
  'led:006RF00000O6tjxYAB': 70,
  'cln:KNO': 71,
  'cln:HGH': 72,
  'cln:NKG': 73,
  'cln:XMN': 74,
  'cln:CGO': 75,
  'cln:TSN': 76,
  'cln:HAK': 77,
  'cln:SYX': 78,
  'cln:HRB': 79,
  'cln:SHE': 80,
  'cln:DLC': 81,
  'cln:CKG': 82,
  'cln:KMG': 83,
  'cln:XIY': 84,
  'cln:WUH': 85,
  'cln:TAO': 86,
  'cln:TNA': 87,
  'cln:CSX': 88,
  'cln:NGB': 89,
  'cln:WNZ': 90,
  'cln:FOC': 91,
  'cln:NNG': 92,
  'cln:KWL': 93,
  'cln:KWE': 94,
  'cln:TYN': 95,
  'cln:HFE': 96,
  'cln:CGQ': 97,
  'cln:HET': 98,
  'cln:TPE': 99,
  'cln:TSA': 100,
  'cln:PUS': 101,
  'led:006RF00000MDf2PYAT': 101,
  'cln:GMP': 102,
  'led:006RF00000MDf2OYAT': 102,
  'cln:KIX': 103,
  'cln:NGO': 104,
  'led:006RF00000CEyGjYAL': 104,
  'cln:FUK': 105,
  'cln:DAD': 106,
  'cln:PEN': 107,
  'led:006RF00000MDf2TYAT': 107,
  'led:006RF00000MDf2UYAT': 107,
  'cln:LGK': 108,
  'led:006RF00000MDf2SYAT': 108,
  'cln:KBV': 109,
  'cln:CNX': 110,
  'led:006Ii000002JKX2IAO': 110,
  'cln:HKT': 111,
  'led:006Ii000002JFZlIAO': 111,
  'led:006RF00000OOPFZYA5': 111,
  'cln:USM': 112,
  'cln:UTH': 113,
  'led:006Ii000002JKZBIA4': 113,
  'cln:HDY': 114,
  'cln:CEI': 115,
  'cln:CXR': 116,
  'cln:PQC': 117,
  'cln:SAI': 118,
  'cln:KTI': 119,
  'cln:RGN': 120,
  'cln:MDL': 121,
  'cln:CEB': 122,
  'cln:DVO': 123,
  'cln:PPS': 124,
  'cln:CRK': 125,
  'cln:UPG': 126,
  'cln:SRG': 127,
  'cln:PLM': 128,
  'cln:PNK': 129,
  'cln:MDC': 130,
  'cln:PKU': 131,
  'cln:BTH': 132,
  'cln:BDJ': 133,
  'cln:KCH': 134,
  'cln:BKI': 135,
  'cln:JHB': 136,
  'cln:KOE': 137,
  'cln:AMQ': 138,
  'cln:SOC': 139,
  'cln:YIA': 140,
  'cln:DJB': 141,
  'cln:TRK': 143,
  'cln:SZB': 144,
  'cln:HLP': 145,
  'cln:MFM': 146,
  'cln:BWN': 147,
  'cln:AMD': 148,
  'cln:PNQ': 149,
  'cln:GOI': 150,
  'cln:GOX': 151,
  'cln:COK': 152,
  'cln:CCJ': 153,
  'cln:CNN': 154,
  'cln:TRV': 155,
  'cln:TRZ': 156,
  'cln:BBI': 157,
  'cln:IXC': 158,
  'cln:LKO': 159,
  'cln:JAI': 160,
  'cln:NAG': 161,
  'cln:IDR': 162,
  'cln:IXM': 163,
  'cln:VNS': 164,
  'cln:IXR': 165,
  'cln:RPR': 166,
  'cln:BHO': 167,
  'cln:VTZ': 168,
  'cln:BDQ': 169,
  'cln:GAU': 170,
  'cln:DIB': 171,
  'cln:IXJ': 172,
  'cln:SXR': 173,
  'cln:ATQ': 174,
  'cln:DED': 175,
  'cln:IXA': 176,
  'cln:GWL': 177,
  'cln:IXD': 178,
  'cln:CMB': 179,
  'cln:MLE': 180,
  'cln:DRV': 181,
  'cln:KTM': 182,
  'cln:DAC': 183,
  'cln:CGP': 184,
  'cln:JSR': 185,
  'cln:ZYL': 186,
  'cln:CXB': 187,
  'cln:SPD': 188,
  'cln:KHI': 189,
  'cln:LHE': 190,
  'cln:ISB': 191,
  'cln:PEW': 192,
  'cln:MUX': 193,
  'cln:LYP': 194,
  'cln:AQJ': 195,
  'cln:MCT': 196,
  'cln:SLL': 197,
  'cln:KWI': 199,
  'cln:AMM': 200,
  'cln:BEY': 201,
  'cln:BGW': 202,
  'cln:TBS': 203,
  'cln:EVN': 204,
  'cln:GYD': 205,
  'cln:MED': 206,
  'cln:RKT': 207,
  'cln:SHJ': 208,
  'cln:DWC': 209,
  'cln:TUU': 210,
  'cln:TIF': 211,
  'cln:ULH': 212,
  'cln:YNB': 213,
  'cln:RAE': 214,
  'cln:EAM': 215,
  'cln:GIZ': 216,
  'cln:AHB': 217,
  'cln:BHH': 218,
  'cln:HAS': 219,
  'cln:ELQ': 220,
  'cln:AJF': 221,
  'cln:WAE': 222,
  'cln:TUI': 223,
  'cln:DWD': 224,
  'cln:LGW': 225,
  'led:006Ii000002JL6BIAW': 225,
  'cln:STN': 226,
  'cln:LTN': 227,
  'cln:MAN': 228,
  'cln:SEN': 230,
  'cln:BHX': 231,
  'cln:EDI': 232,
  'led:006Ii000002JL6KIAW': 232,
  'cln:NCL': 234,
  'cln:LBA': 235,
  'cln:LPL': 236,
  'cln:EMA': 238,
  'cln:ABZ': 239,
  'cln:BHD': 240,
  'cln:BFS': 241,
  'cln:SOU': 242,
  'cln:NWI': 243,
  'cln:EXT': 244,
  'cln:NQY': 245,
  'cln:HUY': 246,
  'cln:MME': 247,
  'cln:IOM': 248,
  'cln:LDY': 249,
  'cln:INV': 250,
  'cln:DUB': 251,
  'cln:SNN': 252,
  'cln:ORK': 253,
  'cln:NOC': 254,
  'cln:LIS': 255,
  'cln:OPO': 256,
  'cln:FAO': 257,
  'cln:VIE': 258,
  'cln:ZRH': 259,
  'cln:GVA': 260,
  'cln:BSL': 261,
  'cln:SZG': 262,
  'cln:INN': 263,
  'cln:GRZ': 264,
  'cln:LNZ': 265,
  'cln:BRU': 266,
  'cln:CRL': 267,
  'cln:CPH': 268,
  'cln:ARN': 269,
  'cln:GOT': 270,
  'cln:HEL': 272,
  'cln:MXP': 273,
  'cln:LIN': 274,
  'cln:BGY': 275,
  'cln:NAP': 276,
  'cln:CTA': 277,
  'cln:PMO': 278,
  'cln:VCE': 279,
  'cln:BLQ': 280,
  'cln:TRN': 281,
  'cln:FLR': 282,
  'cln:PSA': 283,
  'cln:BRI': 284,
  'cln:CAG': 285,
  'cln:DUS': 286,
  'cln:HAM': 287,
  'cln:BER': 288,
  'cln:CGN': 289,
  'cln:HAJ': 291,
  'cln:NUE': 292,
  'cln:FMO': 293,
  'cln:LEJ': 294,
  'cln:DRS': 295,
  'cln:BRE': 296,
  'cln:ATH': 297,
  'cln:HER': 298,
  'cln:RHO': 299,
  'cln:CFU': 300,
  'cln:JMK': 301,
  'cln:SKG': 302,
  'cln:PRG': 303,
  'cln:WAW': 304,
  'cln:WMI': 305,
  'cln:KTW': 306,
  'cln:GDN': 307,
  'cln:POZ': 308,
  'cln:WRO': 309,
  'cln:LUZ': 310,
  'cln:BUD': 311,
  'cln:BTS': 312,
  'cln:KSC': 313,
  'cln:CLJ': 314,
  'cln:TSR': 315,
  'cln:SOF': 317,
  'cln:VAR': 318,
  'cln:BOJ': 319,
  'cln:SKP': 320,
  'cln:TIA': 321,
  'cln:SJJ': 322,
  'cln:ZAG': 323,
  'cln:DBV': 324,
  'cln:TIV': 325,
  'cln:LJU': 326,
  'cln:RIX': 327,
  'cln:TLL': 328,
  'cln:VNO': 329,
  'cln:LUX': 330,
  'cln:NCE': 331,
  'cln:MRS': 332,
  'cln:OSR': 334,
  'cln:BRQ': 335,
  'cln:PFO': 336,
  'cln:LCA': 337,
  'cln:ECN': 338,
  'cln:JER': 339,
  'cln:GIB': 340,
  'cln:LPI': 341,
  'cln:FUE': 342,
  'cln:RTM': 345,
  'cln:SCQ': 346,
  'cln:AYT': 347,
  'cln:ESB': 348,
  'cln:ADB': 349,
  'cln:BJV': 350,
  'cln:DLM': 351,
  'cln:DIY': 352,
  'cln:VII': 353,
  'cln:UIH': 354,
  'cln:VDH': 355,
  'cln:VCS': 356,
  'cln:VCL': 357,
  'cln:TBB': 358,
  'cln:PXU': 359,
  'cln:THD': 360,
  'cln:HPH': 361,
  'cln:HUI': 362,
  'cln:BMV': 363,
  'cln:DIN': 364,
  'cln:VCA': 365,
  'cln:HLD': 366,
  'cln:WUX': 367,
  'cln:NTG': 368,
  'cln:KHN': 369,
  'cln:YTY': 370,
  'cln:CZX': 371,
  'cln:HYN': 372,
  'cln:HIA': 373,
  'cln:WEH': 374,
  'cln:RIZ': 375,
  'cln:WEF': 376,
  'cln:LYG': 377,
  'cln:LZH': 378,
  'cln:NNY': 379,
  'cln:JJN': 380,
  'cln:SWA': 381,
  'cln:WUS': 382,
  'cln:DYG': 383,
  'cln:LJG': 384,
  'cln:JHG': 385,
  'cln:TCZ': 386,
  'cln:DLU': 387,
  'cln:LUM': 388,
  'cln:ZUH': 389,
  'cln:XFN': 390,
  'cln:HJJ': 391,
  'cln:TXN': 392,
  'cln:YNZ': 393,
  'cln:YIW': 394,
  'cln:YCU': 395,
  'cln:YBP': 396,
  'cln:ACX': 397,
  'cln:XUZ': 398,
  'cln:DNH': 399,
  'cln:DAT': 400,
  'cln:BAV': 401,
  'cln:LHW': 402,
  'cln:INC': 403,
  'cln:URC': 404,
  'cln:JGN': 405,
  'cln:JUH': 406,
  'cln:MIG': 407,
  'cln:JGS': 408,
  'cln:YIH': 409,
  'cln:LFQ': 410,
  'cln:AOG': 411,
  'cln:WUA': 412,
  'cln:UYN': 413,
  'cln:JNB': 414,
  'cln:HLA': 415,
  'cln:CPT': 416,
  'cln:DUR': 417,
  'cln:PLZ': 418,
  'cln:BFN': 419,
  'cln:GRJ': 420,
  'cln:ELS': 421,
  'cln:MQP': 422,
  'cln:NBO': 423,
  'cln:MBA': 424,
  'cln:DAR': 425,
  'cln:JRO': 426,
  'cln:EBB': 427,
  'cln:KGL': 428,
  'cln:ADD': 429,
  'cln:LOS': 430,
  'cln:ABV': 431,
  'cln:KAN': 432,
  'cln:ABB': 433,
  'cln:ACC': 434,
  'cln:DLA': 435,
  'cln:LBV': 436,
  'cln:FBM': 437,
  'cln:TNR': 438,
  'cln:LVI': 439,
  'cln:LUN': 440,
  'cln:HRE': 441,
  'cln:BUQ': 442,
  'cln:VFA': 443,
  'cln:WDH': 444,
  'cln:MPM': 445,
  'cln:GBE': 446,
  'cln:MRU': 447,
  'cln:ZNZ': 448,
  'cln:CAI': 449,
  'cln:SSH': 450,
  'cln:HRG': 451,
  'cln:LXR': 452,
  'cln:HBE': 453,
  'cln:ASW': 454,
  'cln:SPX': 455,
  'cln:DBB': 456,
  'cln:TUN': 457,
  'cln:MIR': 458,
  'cln:NBE': 459,
  'cln:CMN': 460,
  'cln:AGA': 461,
  'cln:FEZ': 462,
  'cln:TNG': 463,
  'cln:OUD': 464,
  'cln:NDR': 465,
  'cln:YVR': 466,
  'cln:YUL': 467,
  'cln:YYC': 468,
  'cln:YEG': 469,
  'cln:YOW': 470,
  'cln:YWG': 471,
  'cln:GRU': 472,
  'cln:CGH': 473,
  'cln:VCP': 474,
  'cln:GIG': 475,
  'cln:SDU': 476,
  'cln:REC': 478,
  'cln:BEL': 480,
  'cln:MAO': 481,
  'cln:CWB': 482,
  'cln:CNF': 484,
  'cln:FLN': 486,
  'cln:GYN': 487,
  'cln:NAT': 488,
  'cln:MCZ': 489,
  'cln:JPA': 490,
  'cln:THE': 491,
  'cln:SLZ': 492,
  'cln:UDI': 493,
  'cln:IGU': 494,
  'cln:CGB': 495,
  'cln:CGR': 496,
  'cln:VIX': 497,
  'cln:LDB': 498,
  'cln:JOI': 499,
  'cln:NVT': 500,
  'cln:RAO': 501,
  'cln:CPV': 502,
  'cln:MGF': 503,
  'cln:PMW': 504,
  'cln:JDO': 505,
  'cln:MCP': 506,
  'cln:OPS': 507,
  'cln:BPS': 508,
  'cln:IOS': 509,
  'cln:JJD': 510,
  'cln:AJU': 511,
  'cln:SJP': 512,
  'cln:VDC': 513,
  'cln:XAP': 514,
  'cln:RRJ': 515,
  'cln:BOG': 516,
  'cln:MDE': 517,
  'cln:EOH': 518,
  'cln:CTG': 519,
  'cln:BAQ': 520,
  'cln:SMR': 521,
  'cln:BGA': 522,
  'cln:CUC': 524,
  'cln:PSO': 525,
  'cln:PPN': 526,
  'cln:VUP': 527,
  'cln:NVA': 528,
  'cln:MTR': 529,
  'cln:EYP': 530,
  'cln:EJA': 531,
  'cln:VVC': 532,
  'cln:LET': 533,
  'cln:AXM': 534,
  'cln:PTY': 535,
  'cln:SJO': 536,
  'cln:SAL': 537,
  'cln:ILS': 538,
  'cln:MEX': 539,
  'cln:NLU': 540,
  'cln:TLC': 541,
  'cln:CUN': 542,
  'cln:TQO': 543,
  'cln:MTY': 544,
  'cln:GDL': 545,
  'cln:BJX': 546,
  'cln:QRO': 547,
  'cln:SLP': 548,
  'cln:TRC': 549,
  'cln:AGU': 550,
  'cln:DGO': 551,
  'cln:MZT': 552,
  'cln:CUL': 553,
  'cln:HMO': 554,
  'cln:CUU': 555,
  'cln:MXL': 556,
  'cln:TIJ': 557,
  'cln:REX': 558,
  'cln:TAM': 559,
  'cln:VER': 560,
  'cln:OAX': 561,
  'cln:TGZ': 562,
  'cln:TAP': 563,
  'cln:HUX': 564,
  'cln:ZIH': 565,
  'cln:PVR': 566,
  'cln:MID': 567,
  'cln:VSA': 568,
  'cln:MTT': 569,
  'cln:CJS': 570,
  'cln:CZM': 571,
  'cln:SJD': 572,
  'cln:LAP': 573,
  'cln:PBC': 574,
  'cln:XPL': 575,
  'cln:XNA': 576,
  'cln:CUZ': 578,
  'cln:PIU': 579,
  'cln:TRU': 580,
  'cln:TPP': 581,
  'cln:TBP': 582,
  'cln:PCL': 583,
  'cln:CJA': 584,
  'cln:ATA': 585,
  'cln:CIX': 586,
  'cln:OCC': 587,
  'cln:SCL': 588,
  'cln:CJC': 589,
  'cln:TYL': 590,
  'cln:IQT': 591,
  'cln:EZE': 592,
  'cln:AEP': 593,
  'cln:COR': 594,
  'cln:MDZ': 595,
  'cln:SLA': 596,
  'cln:JUJ': 597,
  'cln:ROS': 598,
  'cln:IGR': 599,
  'cln:BRC': 600,
  'cln:REL': 601,
  'cln:CRD': 602,
  'cln:USH': 603,
  'cln:FTE': 604,
  'cln:LPB': 605,
  'cln:VVI': 606,
  'cln:CBB': 607,
  'cln:GEO': 608,
  'cln:CCS': 609,
  'cln:PTP': 610,
  'cln:DOM': 611,
  'cln:GND': 612,
  'cln:ANU': 613,
  'cln:SJU': 614,
  'cln:NAS': 615,
  'cln:MHH': 616,
  'cln:MBJ': 617,
  'cln:UVF': 618,
  'cln:BDA': 619,
  'cln:PUJ': 620,
  'cln:STI': 621,
  'cln:POP': 622,
  'cln:LRM': 623,
  'cln:SXM': 624,
  'cln:CUR': 625,
  'cln:AUA': 626,
  'cln:BGI': 627,
  'cln:SCY': 628,
  'asp:164': 629,
  'cln:PER': 629,
  'cln:ADL': 630,
  'led:006Ii000002JJwxIAG': 630,
  'cln:CNS': 632,
  'cln:AKL': 636,
  'cln:CHC': 637,
  'cln:ZQN': 639,
  'cln:NAN': 640,
  'cln:VLI': 641,
  'cln:NQZ': 642,
  'cln:TAS': 643,
  'cln:SKD': 644,
  'cln:URA': 645,
  'cln:KGF': 646,
  'cln:GUW': 647,
  'cln:BSZ': 648,
  'cln:VIL': 649,
  'cln:SYR': 650,
  'cln:STL': 651,
  'cln:MCI': 652,
  'cln:COS': 653,
  'cln:TUL': 654,
  'cln:PVD': 655,
  'cln:BDL': 656,
  'cln:CMH': 657,
  'cln:CVG': 658,
  'cln:GSP': 659,
  'cln:ONT': 660,
  'cln:OAK': 661,
  'cln:SMF': 662,
  'cln:HNL': 663,
  'cln:SAN': 664,
  'cln:PDX': 665,
  'cln:AAL': 900,
  'cln:AAP': 900,
  'cln:ABT': 900,
  'cln:ACA': 900,
  'cln:BBK': 900,
  'cln:BJL': 900,
  'cln:BLL': 900,
  'cln:BPN': 900,
  'cln:BUS': 900,
  'cln:CIT': 900,
  'cln:COO': 900,
  'cln:COV': 900,
  'cln:KRK': 900,
  'cln:LOP': 900,
  'cln:MLA': 900,
  'cln:MLB': 900,
  'cln:MSQ': 900,
  'cln:NMI': 900,
  'cln:SJW': 900,
  'cln:URY': 900,
  'cln:YNT': 900,
  'cln:ZAD': 900,
  'cln:ZYI': 900,
}

export function getLoungeOfferRank(loungeId: string): number {
  return LOUNGE_OFFER_RANKS[loungeId] ?? Number.MAX_SAFE_INTEGER
}

export function sortLoungeIdsByRank(loungeIds: Array<string>): Array<string> {
  const originalIndex = new Map(loungeIds.map((id, index) => [id, index]))
  return [...loungeIds].sort((a, b) => {
    const rankDifference = getLoungeOfferRank(a) - getLoungeOfferRank(b)
    return rankDifference === 0 ? (originalIndex.get(a) ?? 0) - (originalIndex.get(b) ?? 0) : rankDifference
  })
}

export default LOUNGE_OFFER_RANKS
